export enum DbMigrationStatus {
    Successful = 'Successful',
    Migrated = 'Migrated',
    Pending = 'Pending',
    Ready = 'Ready',
    Checked = 'Checked',
    PreflightFailed = 'Preflight failed',
    Skipped = 'Skipped',
    DiffChecking = 'Diff Checking',
    DiffFound = 'Diff Found',
    DiffCheckFailed = 'Diff Check Failed',
    Reverted = 'Reverted',
    RevertRequested = 'Revert Requested'
}
